import * as React from "react";
import classNames = require("classnames");

interface Props {
	/**
	 * Quantity value
	 */
	quantity: number;
	/**
	 * On decrement click
	 */
	onDecrementClick: () => void;
	/**
	 * On increment click
	 */
	onIncrementClick: () => void;
	/**
	 * Decrement limit
	 */
	decrementLimit?: number
}

export default class QuantityPicker extends React.Component<Props, {}> {
	render() {
		const { quantity } = this.props;
		const dLimit = this.props.decrementLimit !== undefined ? this.props.decrementLimit : 1;
		const minusClassNames = classNames({
			"icon": true,
			"red": quantity > dLimit,
			"disable": quantity == dLimit,
		});
		return (
			<div className={"quantity-box"}>
				<span className={"quantity-counter"}>
					<span className={minusClassNames}
						  onClick={() => quantity > dLimit && this.props.onDecrementClick()}>
						<i className={"fa fa-minus fa-fw"}/>
					</span>
					<div className={"quantity-number"}>{quantity}</div>
					<span className={"icon blue"} onClick={() => this.props.onIncrementClick()}>
						<i className={"fa fa-plus fa-fw"}/>
					</span>
				</span>
			</div>
		)
	}
}
